import React from 'react';
import { formatNumber } from '@progress/kendo-intl';

export default class EstimateTotalsPanel extends React.Component {

    render() {
        return (
            <div id={this.props.id} className="card shadow">
                <div className="card-body">
                    <h5 className="card-title">Deductible</h5>
                    <div className="row">
                        <label className="col-sm-4">Estimated Charges</label>
                        <div className="col-sm-7 text-right">
                            <div>{formatNumber(this.props.charges, '$0.00')}</div>
                        </div>
                    </div>
                    <div className="row">
                        <label className="col-sm-4">Estimated Allowables</label>
                        <div className="col-sm-7 text-right">
                            <div>{formatNumber(this.props.allowables, '$0.00')}</div>
                        </div>
                    </div>
                    <div className="row">
                        <label className="col-sm-4 minor">Copay Amount</label>
                        <div className="col-sm-7 text-right">
                            <div>{formatNumber(this.props.copayTotal, '$0.00')}</div>
                        </div>
                    </div>
                    <div className="row">
                        <label className="col-sm-4 minor">Deductible Amount</label>
                        <div className="col-sm-7 text-right">
                            <div>{formatNumber(this.props.stillOwed, '$0.00')}</div>
                        </div>
                    </div>
                    <div className="row">
                        <label className="col-sm-4 minor">Co-insurance Amount</label>
                        <div className="col-sm-7 text-right">
                            <div>{formatNumber(this.props.coinsuranceTotal, '$0.00')}</div>
                        </div>
                    </div>
                    <div className="row">
                        <label className="col-sm-4 minor">Max Out Of Pocket Remaining</label>
                        <div className="col-sm-7 text-right">
                            <div>{formatNumber(this.props.maxOutOfPocketRemaining, '$0.00')}</div>
                        </div>
                    </div>
                    <div className="row">
                        <label className="col-sm-4">Estimated Total Customer Amount</label>
                        <div className="col-sm-7 text-right">
                            <div>{formatNumber(this.props.outOfPocketTotal, '$0.00')}</div>
                        </div>
                    </div>
                    <hr />
                    <div className="row">
                        <label className="col-sm-4">Grand Total Balance</label>
                        <div className="col-sm-7 text-right">
                            <div>{formatNumber(this.props.amountDue, '$0.00')}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}